module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAAAoElEQVR4Ae2WoQ0CURBEv0Qgr4zrA4GkACQSidwiKIBSKIMiEAjEyWXk6p1JyMG85NnNM5PsWAMTPMAQSTHDJ0yhFDeYYimWcihEUmRRw+8H6dd3glsuSL++N7wQQWV9WudGkHx993Lr3A3KIkuUW+EgBzVwkIMYHOQgB0Xx+0GVfwpykIP0T36DB0yxC5xGkx18iYOug2QDjzAE7sda+ACzZXVKQrN/BgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/copytxt.png
// module id = 944
// module chunks = 1